import moment from 'moment';

export const INITIAL_VALUES = {
  name: '',
  surname: '',
  department: '',
  date: moment(),
  project: '',
  place: '',
  incident: '',
  description: '',
  cause: '',
  actions: '',
  photo: [],
  reportCopy: false,
  reportEmail: '',
};
